import {
  AppBar,
  Box,
  Container,
  Divider,
  Drawer,
  Grid,
  IconButton,
  useScrollTrigger,
} from "@material-ui/core"
import Toolbar from "@material-ui/core/Toolbar/Toolbar"
import Typography from "@material-ui/core/Typography/Typography"
import SixerLogoDark from "resources/logo/sixer-logo.svg"
import SixerLogoLight from "resources/logo/sixer-logo-footer.svg"
import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import CloseIcon from "@material-ui/icons/Close"
import { AutoExpandSpacer } from "components/elements/Spacer"
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"
import MenuRoundedIcon from "@material-ui/icons/MenuRounded"
import Hidden from "@material-ui/core/Hidden/Hidden"
import List from "@material-ui/core/List/List"
import ListItem from "@material-ui/core/ListItem/ListItem"
import { NavBarButton } from "components/elements/Button"
import DownloadDialog from "components/elements/Download-dialog"
import { bps } from "theme"
import { events } from "analytics/events"
import { pushToFirebase } from "analytics/manager"
import { MobileDownloadManager } from "components/utils/download-manager"
import { isMobile } from "react-device-detect"
import { useLocation } from "@reach/router"
import Button from "@material-ui/core/Button/Button"

const StyledNavContainer = styled.div`
  text-transform: uppercase;

  .solidNav {
    z-index: 999;
    padding: 8px 0px;
    background-color: #fff;
    color: #000;
  }
  .transparentNav {
    padding: 28px 18px;
    z-index: 999;
    background-color: transparent;
    box-shadow: none;
  }

  .white {
    background-color: #fff;
  }

  .fade {
    transition: 0.5s;
  }
  h6 {
    font-weight: 600;
  }

  a {
    position: relative;
    text-decoration: none;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  a:hover {
    text-decoration: none;
  }

  .active {
    padding-top: 3px;
    border-bottom: 3px solid;
  }

  .logo {
    height: 46px;
  }

  .more {
    padding-top: 5px;
    cursor: pointer;
  }

  .popover__content {
    position: relative;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    right: 170px;
    top: 65px;
    transform: translate(0, 10px);
    background-color: #ffffff;
    padding: 12px;
    box-shadow: 0px 10px 20px #0000004d;
    min-width: 250px;
    border-radius: 8px;
    transition: all 0.7s ease-out;
  }

  .popover__wrapper:hover .popover__content {
    z-index: 999;
    opacity: 1;
    visibility: visible;
    min-width: 250px;
    transform: translate(0, -10px);
    transition: all 0.3s ease-out;
  }

  .popover__message {
    padding: 8px 20px;
    color: #212329;
  }
  .popover__message :hover {
    color: #633fb6;
  }

  ${bps.down("md")} {
    .grid-container {
      padding: 0px 24px;
    }
    .transparentNav {
      padding: 6px;
      background-color: transparent;
    }
    .logo {
      max-height: 28px;
    }
  }
`

type Props = {
  window?: () => Window
}

export default ({ window }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState(false)

  const [openDialogName, setOpenDialog] = React.useState(false)

  const location = useLocation()

  let showWebView = false
  if (
    location != null &&
    location.search != null &&
    location.search.includes("isMobileView")
  ) {
    showWebView = true
  }

  const handleClose = () => {
    setAnchorEl(false)
  }

  const openDownloadDialog = () => {
    setOpenDialog(true)
    pushToFirebase(events.web.web_getStarted)
  }

  const closeDialog = () => {
    setOpenDialog(false)
  }

  const [state, setState] = React.useState({
    left: false,
  })

  const drawerItems = [
    ["HOME", "/", "_self"],
    ["GAME RULES", "https://scoring.sixergame.com/game-rules", "_blank", "noopener noreferrer", "false"],
    [
      "SCORING SYSTEM",
      "https://scoring.sixergame.com/scoring-and-pricing",
      "_blank",
      "noopener noreferrer",
      "false", // data-ga-link-decorator
    ],
    // ["ABOUT SIXER", "/about", "_self"],
    ["FAQ", "https://scoring.sixergame.com/faqs", "_blank", "noopener noreferrer", "false"],
    ["DAILY INSIGHTS", "/daily-insights", "_self"],
    ["CAREERS", "/careers", "_self"],
    ["SECURITY & LEGALITY", "/legality", "_self"],
    ["CONTACT US", "/contact", "_self"],
    // ["BECOME AN AMBASSADOR", "/ambassador", "_self"],
  ]

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: isMobile ? 10 : 100,
    target: window ? window() : undefined,
  })

  const handleClick = (event: any) => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget)
    }
  }

  const toggleDrawer = (anchor: string, open: boolean) => (event: any) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }

    setState({ ...state, [anchor]: open })
  }

  const getLinksColor = () => {
    if (
      (location.pathname.includes("ambassador") ||
        location.pathname.includes("careers")) &&
      !trigger
    )
      return {
        color: "#fff",
      }
    else
      return {
        color: "#000",
      }
  }

  const getLogo = () => {
    if (
      (location.pathname.includes("ambassador") ||
        location.pathname.includes("careers")) &&
      !trigger
    )
      return SixerLogoLight
    else return SixerLogoDark
  }

  const list = (anchor: any) => (
    <div
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
      style={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "#54369b",
        color: "#fff",
        fontSize: "24px",
        marginTop: "-8px",
      }}
    >
      <List>
        <div
          style={{
            height: "70px",
            padding: "16px 20px",
            backgroundColor: "#633fb6",
          }}
        >
          <Grid container direction="row" justify="space-between">
            <Grid item>
              <img
                loading="lazy"
                src={SixerLogoLight}
                alt="Sixer logo"
                style={{ width: "120px", height: "40px" }}
              />
            </Grid>
            <Grid item>
              <div
                style={{ float: "right", marginTop: "-12px", color: "#fff" }}
              >
                <IconButton onClick={toggleDrawer(anchor, false)}>
                  <CloseIcon style={{ fill: "white", fontSize: "40px" }} />
                </IconButton>
              </div>
            </Grid>
          </Grid>
        </div>
        {drawerItems.map((text: any, _index: any) => (
          <div key={text[1] + text[0]}>
            {text[1].includes("http") ? (
              <a
                style={{ color: "#fff" }}
                href={text[1]}
                target={text[2]}
                rel={text[3] || ""}
                data-ga-link-decorator={text[4] || ""}
              >
                <ListItem button style={{ padding: "12px 20px" }} component="a">
                  <Typography variant="h6">{text[0]}</Typography>
                </ListItem>
              </a>
            ) : (
              <Link to={text[1]}>
                <ListItem
                  button
                  style={{ padding: "12px 20px", color: "#fff" }}
                  component="a"
                >
                  <Typography variant="h6">{text[0]}</Typography>
                </ListItem>
              </Link>
            )}

            <Divider />
          </div>
        ))}
      </List>
    </div>
  )

  return (
    <StyledNavContainer>
      {/* Mobile Navigation */}
      {!showWebView && (
        <Hidden mdUp implementation="css">
          <AppBar
            className={trigger ? "solidNav fade " : "transparentNav fade "}
          >
            <Toolbar disableGutters>
              <Button href="/" style={{ backgroundColor: "transparent" }}>
                <img
                  loading="lazy"
                  src={getLogo()}
                  alt="Sixer logo"
                  className="logo"
                />
              </Button>
              {!location.pathname.includes("d11") && (
                <>
                  <AutoExpandSpacer />
                  <NavBarButton
                    onClick={() =>
                      MobileDownloadManager(events.web.web_getStarted)
                    }
                    title={"Get Started"}
                  />
                  <Box pr={1} />

                  <IconButton onClick={toggleDrawer("left", true)}>
                    <MenuRoundedIcon style={getLinksColor()} />
                  </IconButton>
                </>
              )}
            </Toolbar>
            <Drawer
              anchor={"left"}
              open={state["left"]}
              onClose={toggleDrawer("left", false)}
            >
              {list("left")}
            </Drawer>
          </AppBar>
        </Hidden>
      )}

      {/* Desktop Navigation */}
      <Hidden smDown implementation="css">
        <AppBar className={trigger ? "solidNav fade " : "transparentNav fade"}>
          <Container maxWidth="lg" disableGutters>
            <Toolbar disableGutters>
              <Grid
                container
                justify="center"
                alignItems="center"
                className="grid-container"
              >
                <Grid item>
                  <Button href="/" style={{ backgroundColor: "transparent" }}>
                    <img
                      loading="lazy"
                      src={getLogo()}
                      alt="sixer logo"
                      className="logo"
                    />
                  </Button>
                </Grid>
                <AutoExpandSpacer />
                {!location.pathname.includes("d11") && (
                  <>
                    <Grid item>
                      <Grid container justify="center" direction="row">
                        <Link
                          to="/"
                          activeClassName="active"
                          style={getLinksColor()}
                        >
                          <Typography variant="h6">Home</Typography>
                        </Link>
                        <Box mx={3} />

                        <Link
                          to="https://scoring.sixergame.com/game-rules"
                          activeClassName="active"
                          style={getLinksColor()}
                        >
                          <Typography variant="h6">Game Rules</Typography>
                        </Link>
                        <Box mx={3} />

                        <Link
                          to="https://scoring.sixergame.com/scoring-and-pricing"
                          target="_blank"
                          activeClassName="active"
                          style={getLinksColor()}
                          rel="noopener noreferrer"
                          data-ga-link-decorator="false"
                        >
                          <Typography variant="h6">Scoring System</Typography>
                        </Link>
                        <Box mx={3} />

                        {/* <Link
                          to="/about"
                          activeClassName="active"
                          style={getLinksColor()}
                        >
                          <Typography variant="h6">About sixer</Typography>
                        </Link>
                        <Box mx={3} /> */}

                        <section
                          onClick={handleClick}
                          onMouseOver={handleClose}
                          style={getLinksColor()}
                          className="popover__wrapper"
                        >
                          <Grid
                            container
                            justify="center"
                            alignContent="flex-end"
                            direction="row"
                            className="more"
                          >
                            <Typography variant="h6">More</Typography>
                            <KeyboardArrowDownIcon />
                          </Grid>

                          <div className="popover__content">
                            <a
                              href="https://scoring.sixergame.com/faqs"
                              target="_blank"
                              rel="noopener noreferrer"
                              data-ga-link-decorator="false"
                            >
                              <Typography
                                className="popover__message"
                                variant="h6"
                              >
                                FAQ
                              </Typography>
                            </a>

                            <Link to="/daily-insights">
                              <Typography
                                variant="h6"
                                className="popover__message"
                              >
                                DAILY INSIGHTS
                              </Typography>
                            </Link>

                            <Link to="/careers">
                              <Typography
                                className="popover__message"
                                variant="h6"
                              >
                                Careers
                              </Typography>
                            </Link>

                            <Link to="/legality">
                              <Typography
                                className="popover__message"
                                variant="h6"
                              >
                                SECURITY & LEGALITY
                              </Typography>
                            </Link>

                            <Link
                              to="/contact"
                              onClick={() => {
                                pushToFirebase(events.web.web_home_CTA_contact)
                              }}
                            >
                              <Typography
                                className="popover__message"
                                variant="h6"
                              >
                                CONTACT US
                              </Typography>
                            </Link>
                          </div>
                        </section>
                        <Box mx={3} />
                        <NavBarButton
                          onClick={openDownloadDialog}
                          title={"Get Started"}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            </Toolbar>
          </Container>
        </AppBar>
        <Hidden smDown implementation="css">
          <DownloadDialog
            open={openDialogName == true}
            handleClose={closeDialog}
          />
        </Hidden>
      </Hidden>
    </StyledNavContainer>
  )
}
